import React from 'react';

import { Box } from '@mui/material';

export const TreatmentOnGoingTabListIndicatorLine: React.FC = () => {
  return (
    <Box
      height={40}
      sx={{
        position: 'absolute',
        width: 'calc(100% + 2px)',
        left: '-1px',
        bottom: -14,
        backgroundColor: '#FBB45F40',
        borderTopLeftRadius: 6,
        borderTopRightRadius: 6,
      }}
    />
  );
};
